import styled from '@emotion/styled';

import { DTFSizeTypes, SemboSizeTypes } from './PrimaryIcon.types';

export const ImageWrapper = styled.img<{ market: string }>`
  width: ${({ market }) =>
    market === 'Sembo'
      ? SemboSizeTypes['MEDIUM'].w
      : DTFSizeTypes['MEDIUM'].w}px;
  height: ${({ market }) =>
    market === 'Sembo'
      ? SemboSizeTypes['MEDIUM'].h
      : DTFSizeTypes['MEDIUM'].h}px;

  @media (min-width: 768px) {
    width: ${({ market }) =>
      market === 'Sembo'
        ? SemboSizeTypes['LARGE'].w
        : DTFSizeTypes['LARGE'].w}px;
    height: ${({ market }) =>
      market === 'Sembo'
        ? SemboSizeTypes['LARGE'].h
        : DTFSizeTypes['LARGE'].h}px;
  }
`;
